import {
    AlphaAnalysisApi,
    AlphaPicksApi,
    APICredentialsApi,
    Configuration, JobMonitoringApi, MarketCapApi, MarketCapApiAxiosParamCreator, MarketDataApi,
    SeekingAlphaApi,
    Trading212AccountApi, Trading212CFDApi,
    Trading212CredentialsApi,
    Trading212PublicAPIApi, UserCallbackURLApi,
    UserManagementApi
} from "../api";
import apiAxios from "./apiClient";

const apiConfig = new Configuration({
    basePath: process.env.REACT_APP_API_URL || "http://localhost:8080",
});

export const userManagementApi = new UserManagementApi(apiConfig, undefined, apiAxios);
export const seekingAlphaApi = new SeekingAlphaApi(apiConfig, undefined, apiAxios);
export const trading212CredentialsApi = new Trading212CredentialsApi(apiConfig, undefined, apiAxios);
export const trading212AccountApi = new Trading212AccountApi(apiConfig, undefined, apiAxios);
export const trading212CFDApi = new Trading212CFDApi(apiConfig, undefined, apiAxios);
export const trading212PublicApi = new Trading212PublicAPIApi(apiConfig, undefined, apiAxios);
export const jobMonitoringApi = new JobMonitoringApi(apiConfig, undefined, apiAxios);
export const userCallbackURLApi = new UserCallbackURLApi(apiConfig, undefined, apiAxios);
export const apiCredentialsApi = new APICredentialsApi(apiConfig, undefined, apiAxios);
export const marketCapApi = new MarketCapApi(apiConfig, undefined, apiAxios);
export const marketDataApi = new MarketDataApi(apiConfig, undefined, apiAxios);
export const alphaAnalysisApi = new AlphaAnalysisApi(apiConfig, undefined, apiAxios);
export const alphaPicksApi = new AlphaPicksApi(apiConfig, undefined, apiAxios);

export type TriggerRunMode = 'LIVE' | 'MOCK_SCANNER_REAL_BUY' | 'MOCK_BOTH';

export const triggerScheduledTask = (
    credentialKey: string,
    runMode: TriggerRunMode,
    mockArticleId?: string,
    mockInjectAtAttempt?: number,
    parallelJobs?: number,
) =>
    apiAxios.post(
        `${apiConfig.basePath}/api/seeking-alpha/trigger-scheduled-task`,
        null,
        { params: { credentialKey, runMode, mockArticleId, mockInjectAtAttempt, parallelJobs } },
    );
